import React, {Component} from "react";
import {Popconfirm} from "antd";
import BaseComponent from "../../../../../base/BaseComponent";

export default class TableOperation extends BaseComponent {

    render() {
        const {data, delRole,showMenuEdit} = this.props;
        return (
            <div style={{display: "flex"}}>
                <span className="cm-link margin-right-15" onClick={()=>showMenuEdit(data)}>绑定菜单</span>
                <Popconfirm
                    title={`确定删除角色：${data.roleName}`}
                    onConfirm={() => {delRole(data)}}
                    okText="确定"
                    cancelText="取消"
                >
                    <span className="cm-link">删除</span>
                </Popconfirm>
            </div>
        );
    }
}

